import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'antd/dist/antd.css';
import configureStore from './store/store';
import AppRouter from './containers/AppRouter';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
export const store = configureStore();
// export const backendUrl = 'localhost:3001';
// export const backendUrl = '0.0.0.0:3001';
// export const backendUrl = 'backend.rtvcrespo.es:3001';
export const backendUrl = 'https://backend.rtvcrespo.es';
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#FF6A6A'
        },
        secondary: {
            main: '#000057'
        }
    }
});


class App extends Component {
    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <BrowserRouter>
                    <Provider store={store}>
                        <AppRouter />
                    </Provider>
                </BrowserRouter>
            </MuiThemeProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js